import { render, staticRenderFns } from "./CatalogueEventRecommendation.vue?vue&type=template&id=4073083d&scoped=true&"
import script from "./CatalogueEventRecommendation.vue?vue&type=script&lang=js&"
export * from "./CatalogueEventRecommendation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4073083d",
  null
  
)

export default component.exports